import { CommentPosition, LoadedCommentsState } from 'src/app/interfaces/posts.interface';

class RootCommentFormStatus {
  private rootFormChanged: boolean;
  private childFormsChanged: boolean[];

  public constructor(numChildForms: number) {
    this.rootFormChanged = false;
    this.childFormsChanged = new Array<boolean>(numChildForms).fill(false);
  }

  public isFormChanged(): boolean {
    return this.rootFormChanged || this.childFormsChanged.findIndex((childFormState: boolean) => childFormState) !== -1;
  }

  public updateRootCommentStatus(isFormChanged: boolean): void {
    this.rootFormChanged = isFormChanged;
  }

  public updateReplyCommentStatus(isFormChanged: boolean, childCommentIndex: number): void {
    this.childFormsChanged[childCommentIndex] = isFormChanged;
  }
}

export class CommentFormStatus {
  private mainFormChanged: boolean;
  private rootCommentFormStatuses: RootCommentFormStatus[];

  public constructor(loadedComments: LoadedCommentsState) {
    this.mainFormChanged = false;
    this.rootCommentFormStatuses = new Array<RootCommentFormStatus>(loadedComments.loadedRootCommentsCount);
    for (let i = 0; i < loadedComments.loadedRootCommentsCount; i++) {
      this.rootCommentFormStatuses[i] = new RootCommentFormStatus(
        loadedComments.rootCommentFullViews[i].loadedReplyCommentsCount,
      );
    }
  }

  public isFormChanged(): boolean {
    return (
      this.mainFormChanged ||
      this.rootCommentFormStatuses.findIndex((rootFormStatus: RootCommentFormStatus) =>
        rootFormStatus.isFormChanged(),
      ) !== -1
    );
  }

  public updateMainFormStatus(isFormChanged: boolean): void {
    this.mainFormChanged = isFormChanged;
  }

  public updateCommentFormStatus(isFormChanged: boolean, commentPosition: CommentPosition): void {
    const rootCommentFormStatus: RootCommentFormStatus = this.rootCommentFormStatuses[commentPosition.indexRoot];
    if (commentPosition.indexReply) {
      rootCommentFormStatus.updateReplyCommentStatus(isFormChanged, commentPosition.indexReply);
    } else {
      rootCommentFormStatus.updateRootCommentStatus(isFormChanged);
    }
  }
}
